import { House } from 'lucide-react'
import { useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

interface FlatImageProps {
  src?: string | null
  alt?: string
  className?: string
  iconClassName?: string
  loading?: 'lazy' | 'eager'
}

/**
 * Flat image that falls back to a placeholder when the source is missing or
 * fails to load (e.g. the image URL 404s).
 */
export function FlatImage({
  src,
  alt,
  className,
  iconClassName,
  loading
}: FlatImageProps) {
  const [failed, setFailed] = useState(false)

  // Reset the error state when the source changes.
  useEffect(() => setFailed(false), [src])

  if (!src || failed) {
    return (
      <div
        className={cn(
          'flex items-center justify-center bg-ink/[0.04]',
          className
        )}
        aria-label={alt}
      >
        <House className={cn('h-10 w-10 text-ink/20', iconClassName)} />
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      className={className}
      onError={() => setFailed(true)}
    />
  )
}
